module.exports = __webpack_public_path__ + "static/img/cgal2.8ffeae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal2.png
// module id = 92vv
// module chunks = 1